import { render, staticRenderFns } from "./RegisteredSpecialties.vue?vue&type=template&id=07b1c39e&scoped=true"
import script from "./RegisteredSpecialties.vue?vue&type=script&lang=js"
export * from "./RegisteredSpecialties.vue?vue&type=script&lang=js"
import style0 from "./RegisteredSpecialties.vue?vue&type=style&index=0&id=07b1c39e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b1c39e",
  null
  
)

export default component.exports